module.exports = __webpack_public_path__ + "img/pic.4174ae5e.png";